import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  redeemGiftDetailData: null,
};

const redeemGiftDetailSlice = createSlice({
  name: "redeemGiftDetail",
  initialState,
  reducers: {
    setRedeemGiftDetailData: (state, action) => {
      state.redeemGiftDetailData = action.payload;
    },
    clearRedeemGiftDetailData: (state) => {
      state.redeemGiftDetailData = null;
    },
  },
});

export const { setRedeemGiftDetailData,clearRedeemGiftDetailData } = redeemGiftDetailSlice.actions;
export default redeemGiftDetailSlice.reducer;
